import { App, Form, Modal, Radio } from "antd";
import { useEffect } from "react";

import styles from "../OrderForms/FinancialForm.module.css";
import {
  ZUU_RPQ_QUESTIONS,
  type ZuuRiskInvestmentProfile,
} from "./zuuRpqQuestions";

type Props = {
  open: boolean;
  value?: ZuuRiskInvestmentProfile;
  readOnly?: boolean;
  onCancel: () => void;
  onSave: (value: ZuuRiskInvestmentProfile) => void;
};

export function ZuuRiskInvestmentQuestionnaireModal({
  open,
  value,
  readOnly = false,
  onCancel,
  onSave,
}: Props) {
  const [form] = Form.useForm<ZuuRiskInvestmentProfile>();
  const { message } = App.useApp();

  useEffect(() => {
    if (open) {
      form.setFieldsValue(value || {});
    }
  }, [form, open, value]);

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      onSave(values);
    } catch {
      message.error("風險及投資取向分析問卷還有問題未填寫。");
    }
  };

  return (
    <Modal
      title="風險及投資取向分析問卷"
      open={open}
      onCancel={onCancel}
      width="min(860px, calc(100vw - 24px))"
      centered
      wrapClassName={styles.zuuRpqModal}
      maskClosable={false}
      destroyOnClose={false}
      footer={readOnly ? null : undefined}
      okText="保存"
      cancelText="取消"
      onOk={handleSave}
      styles={{
        body: {
          overflowY: "auto",
          overflowX: "hidden",
          paddingTop: 12,
          paddingBottom: 12,
        },
      }}
    >
      <div className={styles.zuuRpqScrollArea}>
      <Form form={form} layout="vertical" disabled={readOnly}>
        {ZUU_RPQ_QUESTIONS.map((question) => (
          <Form.Item
            key={question.key}
            name={question.key}
            label={question.label}
            rules={[{ required: true, message: question.requiredMessage }]}
            className={styles.zuuRpqFormItem}
          >
            <Radio.Group className={styles.zuuFullWidth}>
              <div className={question.layout === "grid-2" ? styles.zuuRpqOptionGrid : question.layout === "inline-2" ? styles.zuuRpqOptionInlineGrid : styles.zuuOptionColumn}>
                {question.options.map((option) => (
                  <Radio key={option.key} value={option.key} className={styles.zuuLongTextOption}>
                    {option.key}. {option.label}
                  </Radio>
                ))}
              </div>
            </Radio.Group>
          </Form.Item>
        ))}
      </Form>
      </div>
    </Modal>
  );
}
